import { render } from "./AddTeamMember.vue?vue&type=template&id=156a2b08"
import script from "./AddTeamMember.vue?vue&type=script&lang=js"
export * from "./AddTeamMember.vue?vue&type=script&lang=js"
script.render = render

export default script